import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[phoneMask]'  // This is the selector you'll use in your HTML template
})
export class PhoneMaskDirective {
    constructor(private el: ElementRef) { }

    @HostListener('input', ['$event'])
    onInput(event: any) {
        let value = event.target.value;

        // Remove all non-numeric characters
        value = value.replace(/\D/g, '');

        // Apply the phone number mask (format: (xxx) xxx-xxxx)
        if (value.length <= 3) {
            value = `(${value}`;
        } else if (value.length <= 6) {
            value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
        } else {
            value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
        }

        // Set the formatted value back to the input element
        this.el.nativeElement.value = value;
    }
}
